/*|=================================================|
  |  Asahi theme scripts                            |
  |=================================================| */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* -------------------------------------------------
   * Mobile navigation
   * ------------------------------------------------- */
  var hamburger = document.getElementById("hamburger");
  var mobileMenu = document.getElementById("mobile-menu");

  if (hamburger && mobileMenu) {
    var setMenu = function (open) {
      hamburger.classList.toggle("is-open", open);
      mobileMenu.classList.toggle("is-open", open);
      hamburger.setAttribute("aria-expanded", open ? "true" : "false");
      mobileMenu.setAttribute("aria-hidden", open ? "false" : "true");
      document.body.classList.toggle("menu-open", open);
    };

    hamburger.addEventListener("click", function () {
      setMenu(!mobileMenu.classList.contains("is-open"));
    });

    // Close when a navigation link is tapped
    mobileMenu.addEventListener("click", function (e) {
      if (e.target.closest("a")) {
        setMenu(false);
      }
    });

    // Close on Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        setMenu(false);
        hamburger.focus();
      }
    });

    // Reset when resizing up to the desktop breakpoint
    window.addEventListener("resize", function () {
      if (window.innerWidth >= 768 && mobileMenu.classList.contains("is-open")) {
        setMenu(false);
      }
    });
  }

  /* -------------------------------------------------
   * Reading progress bar (post pages only)
   * ------------------------------------------------- */
  var article = document.querySelector(".post-content");
  if (article) {
    var bar = document.createElement("div");
    bar.className = "reading-progress";
    bar.setAttribute("role", "presentation");
    document.body.appendChild(bar);

    var updateProgress = function () {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) : 0;
      bar.style.transform = "scaleX(" + pct + ")";
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress, { passive: true });
  }

  /* -------------------------------------------------
   * Scroll reveal for post cards
   * ------------------------------------------------- */
  if (!reduceMotion && "IntersectionObserver" in window) {
    var revealTargets = document.querySelectorAll(".post-card");
    if (revealTargets.length) {
      revealTargets.forEach(function (el) {
        el.classList.add("reveal");
      });
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      revealTargets.forEach(function (el) {
        observer.observe(el);
      });
    }
  }
})();
